import produce from 'immer';
import { Reducer } from 'redux';

interface IUpdateCustomerBrandSelectionAction {
    type: 'customerHotelBrandSelection/updateBrand';
    payload: number | undefined;
}

interface IUpdateCustomerClientSelectionAction {
    type: 'customerHotelBrandSelection/updateClient';
    payload: number | undefined;
}

interface IUpdateCustomerHotelSelectionAction {
    type: 'customerHotelBrandSelection/updateHotel';
    payload: number | undefined;
}

export const updateHotelSelection = (hotelId?: number): IUpdateCustomerHotelSelectionAction => ({
    type: 'customerHotelBrandSelection/updateHotel',
    payload: hotelId,
});

export const updateBrandSelection = (brandId?: number): IUpdateCustomerBrandSelectionAction => ({
    type: 'customerHotelBrandSelection/updateBrand',
    payload: brandId,
});

export const updateClientSelection = (clientId?: number): IUpdateCustomerClientSelectionAction => ({
    type: 'customerHotelBrandSelection/updateClient',
    payload: clientId,
});

export interface IHotelBrandSelectionState {
    brandId?: number;
    hotelId?: number;
    clientId?: number;
}

type HotelBrandSelectionAction = IUpdateCustomerBrandSelectionAction | IUpdateCustomerHotelSelectionAction | IUpdateCustomerClientSelectionAction;

const defaultValue: IHotelBrandSelectionState = { brandId: undefined, hotelId: undefined };

export const hotelBrandSelectionReducer: Reducer<IHotelBrandSelectionState, HotelBrandSelectionAction> = produce(
    (state: IHotelBrandSelectionState, action: HotelBrandSelectionAction) => {
        switch (action.type) {
            case 'customerHotelBrandSelection/updateBrand':
                state.brandId = action.payload;
                break;
            case 'customerHotelBrandSelection/updateHotel':
                state.hotelId = action.payload;
                break;
            case 'customerHotelBrandSelection/updateClient':
                state.clientId = action.payload;
                break;
        }
    },
    defaultValue
);

export const hotelBrandSelectionSelector = (state: { hotelBrandSelection: IHotelBrandSelectionState }) => state.hotelBrandSelection;
